module.exports = __webpack_public_path__ + "img/free_multiplier_4.e93a04b8.png";